import { Banner } from '../../../../../hexagon/models/BannerModel';

export const aBanner: Banner = {
    content: 'Hello Banner',
    backgroundColor: '#000000',
    textColor: '#ffffff',
};
